export enum ButtonVariant {
	Transparent = 'transparent',
	Brand = 'brand',
	Red = 'red',
	Blue = 'blue',
	Dark = 'dark',
	DarkBorder = 'dark-border',
	LightBorder = 'light-border',
	Light = 'light',
	Green = 'green',
	GreenBorder = 'green-border',
	Yellow = 'yellow'
}
